/**
 * date 的各工具方法
 */
//
const today = new Date()
export default {
  getTimeObj (h, m, s) {
    let d = new Date()
    h = h < 0 ? d.getHours() : h
    m = m < 0 ? d.getMinutes() : m
    s = s < 0 ? d.getSeconds() : s
    // let utc = Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate(), h, m, s)
    return new Date(today.getFullYear(), 0, 1, h, m, s)
  },
  /**
   * 将 date 字符串转换成 date 对象。
   * 可以是时间戳（number类型或字符类型都可以）
   * 可以是时间格式字符串（如：'yyyy-MM-dd'）
   * @param dateString
   * @returns {Date}
   */
  convertDate4String (dateString) {
    if (dateString instanceof Date) return dateString
    let timeStamp = Number(dateString)
    let isInteger = Number.isInteger(timeStamp)
    if (isInteger) return new Date(timeStamp)
    else return new Date(dateString)
  },
  convertTime4String (dateString) {
    if (dateString instanceof Date) return dateString.getTime() + 8.64e7
    let timeStamp = Number(dateString)
    let isInteger = Number.isInteger(timeStamp)
    if (isInteger) return new Date(timeStamp).getTime()
    else return new Date(dateString).getTime()
  },
  /**
   * 接收: HH:mm:ss
   * 返回：date
   * @param timeStr
   * @returns {Date}
   */
  getHmsDate (timeStr) {
    let a = timeStr.split(':')
    if (a && a.length !== 0) {
      if (a.length === 2) {
        a[2] = '00'
      }
      return new Date(today.getFullYear(), 0, 1, parseInt(a[0]), parseInt(a[1]), parseInt(a[2]))
    } else {
      console.log('getHmsDate 取值错误')
    }
  },
  /*
 接收两个 date 对象
 如果 date1 大， 返回：1
 如果 date1 小， 返回：-1
 如果 相等，     返回：0
  */
  dateCompare (date1, date2, isShowLog) {
    if (isShowLog) {
      console.log(date1.Format('yyyy-MM-dd HH:mm:ss'))
    }
    if (date1 && date2) {
      if (date1.getTime() > date2.getTime()) return 1
      else if (date1.getTime() < date2.getTime()) return -1
      else return 0
    } else {
      return -2
    }
  },

  isSameDate (date1, date2) {
    if (date1 && date2) {
      date1.setHours(0, 0, 0, 0)
      date2.setHours(0, 0, 0, 0)
      if (date1.getTime() > date2.getTime()) return 1
      else if (date1.getTime() < date2.getTime()) return -1
      else return 0
    } else {
      return -2
    }
  },
  /**
   * 接收 date对象 或 日期字符串， 转换为格式： yyyy-MM-dd
   * 弃用：已在 Date对象中扩展了方法:Date.Format
   */
  getFormatDate (date) {
    if (!date || date === '') return null
    let subDate
    if (date instanceof Date) {
      subDate = date
    } else {
      subDate = new Date(date)
    }
    let y = subDate.getFullYear()
    let m = subDate.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = subDate.getDate()
    d = d < 10 ? ('0' + d) : d
    return y + '-' + m + '-' + d
  },
  // 接收 时间戳（毫秒） 转换为格式： yyyy-MM-dd
  getDateStrByTimestamp (timestamp) {
    if (!timestamp || timestamp === '') return ''
    timestamp = parseInt(timestamp)
    if (timestamp.toString().length < 13) timestamp *= 1000
    return this.getFormatDate(new Date(timestamp))
  },
  /**
   * 接收：date
   * 返回：HH:mm:ss
   * @param timeDate
   * @returns {string}
   */
  getTimeStr (timeDate, number) {
    if (!timeDate) return ''
    if (timeDate) {
      let h = timeDate.getHours()
      let m = timeDate.getMinutes()
      let s = timeDate.getSeconds()
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      s = s < 10 ? '0' + s : s
      if (number === 2) {
        if (s < 30) return h + ':' + m
        else if (m === 59) return ++h + ':00'
        else return h + ':' + ++m
      } else {
        return h + ':' + m + ':' + s
      }
    }
  },
  getHmsFormat (timeStr, format) {

  },
  // 接收 HH:mm:ss 时间字符串，返回 date 对象
  getDateByAtwillDate (timeStr) {
    if (!timeStr || timeStr === '') return ''
    let a = timeStr.split(':')
    if (this.isNotEmpty(a)) {
      return new Date(1970, 0, 1, a[0], a[1], a[2])
    }
  },
  // 接收 date 对象， 返回时间 HH:mm:ss
  getTimeStrByAtwillDate (d) {
    if (!d) return ''
    if (this.isNotEmpty(d)) {
      let h = d.getHours()
      let m = d.getMinutes()
      let s = d.getSeconds()
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      s = s < 10 ? '0' + s : s
      return h + ':' + m + ':' + s
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js